import { Button, Divider, Row, Typography } from 'antd';
import { FC } from 'react';
import { useNavigate } from 'react-router-dom';

import { useBreadcrumbs } from 'src/features/layout/hooks/useBreadcrumbs';

import { ListBannerManagementTable } from '../components/ListBannerManagementTable';

const { Title } = Typography;

export const BannerManagementScreen: FC = () => {
  useBreadcrumbs([
    {
      label: 'Loja',
    },
    {
      label: 'Banners',
    },
    {
      label: 'Gerenciamento',
    },
  ]);

  const navigate = useNavigate();

  return (
    <>
      <Row style={{ marginBottom: '24px' }} justify='space-between'>
        <Title level={3}>Gestao de Banners</Title>

        <Button
          type='primary'
          onClick={() => navigate('/marketplace/banners/create-or-update')}
        >
          + Novo Banner
        </Button>
      </Row>

      <Divider style={{ marginBottom: '24px' }} />

      <ListBannerManagementTable />
    </>
  );
};
